module.exports = __webpack_public_path__ + "static/media/logo-televisa-acervo.b1776fef.png";